import { parseAsStringLiteral, useQueryState } from 'nuqs';

import { forumTags } from '~/api/forum/constants';
import { SearchParamKeys } from '~/constants/url';

export const useForumTagFilter = () => useQueryState(SearchParamKeys.FILTER_FORUM_TAG, parseAsStringLiteral(forumTags));
